module.exports = __webpack_public_path__ + "img/06.e8844184.png";